import request from '../request'
// 获取信息列表
export function getInfoList(params = {}) {
  return request({
    method: 'GET',
    url: '/verify/page/information/list',
    params
  })
}
// 修改信息
export function putInfoOne(data = {}) {
  return request({
    method: 'POST',
    url: '/verify/page/information/onepost',
    data
  })
}
// 删除信息
export function delInfoOne(params = {}) {
  return request({
    method: 'DELETE',
    url: '/verify/page/information/one',
    params
  })
}
// 添加信息
export function addInfoOne(data = {}) {
  return request({
    method: 'POST',
    url: '/verify/page/information/one',
    data
  })
}
// 添加图片
export function addImgOnn(data = {}) {
  return request({
    method: 'POST',
    url: '/verify/page/information/picture/one',
    data,
    type: 'img'
  })
}
// 添加英文语音
export function addVoiceEn(data = {}) {
  return request({
    method: 'POST',
    url: '/verify/page/information/voiceE',
    data,
    type: 'img'
  })
}
// 添加中文语音
export function addVoiceZn(data = {}) {
  return request({
    method: 'POST',
    url: '/verify/page/information/voiceZ',
    data,
    type: 'img'
  })
}
// 添加方言语音
export function addVoiceFn(data = {}) {
  return request({
    method: 'POST',
    url: '/verify/page/information/voiceF',
    data,
    type: 'img'
  })
}
// 批量导入
export function InfoImport(data = {}) {
  return request({
    method: 'POST',
    url: '/page/information/import',
    data,
    type: 'img'
  })
}
// 添加视频
export function addVideo(data = {}) {
  return request({
    method: 'POST',
    url: '/verify/page/information/voicevoide',
    data,
    type: 'mp4'
  })
}